// eslint-disable-next-line import/prefer-default-export
export const getPersonItemRowId = (person) => {
  return `person-item-${person.aggregateId}`;
};
